/**
 * This is a component for a default form with method='post'. The item will be rendered with
 * the childComponent passed in as a prop.
 *
 * @module components/Form
 */

import PropTypes from 'prop-types';
import React from 'react';

export class DeprecatedForm extends React.Component {
  /**
   * @property {Node} children - something to be rendered as a header for the grid.
   */
  static propTypes = {
    children: PropTypes.node,
    onSubmit: PropTypes.func,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    autoComplete: PropTypes.string,
    className: PropTypes.string,
  };

  static defaultProps = {
    onSubmit: () => {},
    onChange: () => {},
    onBlur: () => {},
  };

  onSubmit = e => {
    e.preventDefault();
    this.props.onSubmit();
  };

  render() {
    return (
      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
      <form
        className={this.props.className}
        method='post'
        onSubmit={this.onSubmit}
        onBlur={this.props.onBlur}
        onChange={this.props.onChange}
        autoComplete={this.props.autoComplete}
      >
        {this.props.children}
      </form>
    );
  }
}

export default DeprecatedForm;
